module.exports = __webpack_public_path__ + "assets/img/solution2.b061402a.png";